import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggle(event) {
    event.preventDefault()

    const darkLink = document.querySelector("link[data-theme='dark']")
    if (darkLink) {
      darkLink.disabled = !darkLink.disabled
    }

    // Toggle icon between moon and sun
    const icon = this.element.querySelector("i")
    if (icon) {
      icon.classList.toggle("fa-moon")
      icon.classList.toggle("fa-sun")
    }

    // Also toggle the other dropdown's icon (mobile/desktop)
    document.querySelectorAll("[data-controller='theme'] i").forEach((i) => {
      if (i !== icon) {
        i.classList.toggle("fa-moon")
        i.classList.toggle("fa-sun")
      }
    })

    // Persist to DB
    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content
    fetch("/theme", {
      method: "GET",
      headers: {
        "Accept": "application/json",
        "X-CSRF-Token": csrfToken
      }
    })
  }
}
